import React, { useState, useEffect } from "react";
import "./Account.scss";
import PersonalTabs from "./PersonalTabs/PersonalTabs";
import HoaHongLayout from "./HoaHong/HoaHongLayout";
import NapTien from "./NapTien/NapTien";
import { LichSuCuoc } from "./LichSuCuoc";
import RutTien from "./RutTien/RutTien";
import { useLocation } from "react-router-dom";
import LichSuNap from "./NapTien/LichSuNap/LichSuNap";

const SidebarButton = ({
  icon,
  label,
  onClick,
  isActive,
  img,
  imgnoactive,
}) => (
  <button
    className={`sidebar-button ${isActive ? "active" : ""}`}
    onClick={onClick}
  >
    <i
      className={`icon ${icon}`}
      style={{
        backgroundImage: `url(${isActive ? img : imgnoactive})`,
      }}
    />
    <span>{label}</span>
  </button>
);

export default function Account() {
  const [activeSidebar, setActiveSidebar] = useState("personal");
  const [activeTab, setActiveTab] = useState("messages");

  const location = useLocation();

  useEffect(() => {
    if (location.state?.tab) {
      setActiveSidebar(location.state.tab);
    }
  }, [location.state]);

  const renderMainContent = () => {
    switch (activeSidebar) {
      case "personal":
        return (
          <PersonalTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        );

      case "invite":
        return <HoaHongLayout />;

      case "deposit":
        return <NapTien />;

      case "withdraw":
        return <RutTien />;

      case "history":
        return <LichSuNap />;

      // case "history":
      //   return <LichSuCuoc />;

      default:
        return null;
    }
  };

  return (
    <div className="message-page">
      <div className="container-account">
        {/* Sidebar */}
        <nav className="sidebar">
          <div className="sidebar_tong">

            <SidebarButton
              icon="fas fa-user-friends"
              label="ข้อมูลส่วนตัว"
              isActive={activeSidebar === "personal"}
              onClick={() => setActiveSidebar("personal")}
              img="/laptop/thongtincanhan/thongtincanhan.png"
              imgnoactive="/laptop/thongtincanhan/thongtincanhannocative.png"
            />

            <SidebarButton
              icon="fas fa-gem"
              label="เชิญเพื่อน"
              isActive={activeSidebar === "invite"}
              onClick={() => setActiveSidebar("invite")}
              img="/laptop/thongtincanhan/moibanbe.png"
              imgnoactive="/laptop/thongtincanhan/moibanbenoactive.png"
            />

            <SidebarButton
              icon="fas fa-piggy-bank"
              label="ฝากเงิน"
              isActive={activeSidebar === "deposit"}
              onClick={() => setActiveSidebar("deposit")}
              img="/laptop/thongtincanhan/naptien.png"
              imgnoactive="/laptop/thongtincanhan/naptiennoactive.png"
            />

            <SidebarButton
              icon="fas fa-wallet"
              label="ถอนเงิน"
              isActive={activeSidebar === "withdraw"}
              onClick={() => setActiveSidebar("withdraw")}
              img="/laptop/thongtincanhan/ruttien.png"
              imgnoactive="/laptop/thongtincanhan/ruttiennoactive.png"
            />

            <SidebarButton
              icon="fas fa-clipboard-list"
              label="ประวัติฝาก-ถอน"
              isActive={activeSidebar === "history"}
              onClick={() => setActiveSidebar("history")}
              img="/laptop/thongtincanhan/lichsuccuoc.png"
              imgnoactive="/laptop/thongtincanhan/lichsucuocnoactive.png"
            />

          </div>
        </nav>

        <main className="main-content">
          {renderMainContent()}
        </main>
      </div>
    </div>
  );
}